import { SpaceTemplatesRepository } from './services/space-templates-repository.interface';
import { SpaceTemplatesRepositoryImpl } from './repositories/space-templates-repository';
import { SpaceTemplatesService } from './services/space-templates-service.interface';
import { SpaceTemplatesServiceImpl } from './services/space-templates-service';
import { ApiQuerySpaceTemplates } from './repositories/apis/api-query-space-templates.interface';
import { SpaceApiServiceImpl } from '@/infrastructure/api-functions/space-api-service';
export function spaceTemplatesModule(bind) {
    bind(SpaceTemplatesService).to(SpaceTemplatesServiceImpl);
    bind(SpaceTemplatesRepository).to(SpaceTemplatesRepositoryImpl);
    bind(ApiQuerySpaceTemplates).to(SpaceApiServiceImpl);
}
